import { render, staticRenderFns } from "./LotteryIndex.vue?vue&type=template&id=bcec77b6&scoped=true"
import script from "./LotteryIndex.vue?vue&type=script&lang=js"
export * from "./LotteryIndex.vue?vue&type=script&lang=js"
import style0 from "./LotteryIndex.vue?vue&type=style&index=0&id=bcec77b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcec77b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcec77b6')) {
      api.createRecord('bcec77b6', component.options)
    } else {
      api.reload('bcec77b6', component.options)
    }
    module.hot.accept("./LotteryIndex.vue?vue&type=template&id=bcec77b6&scoped=true", function () {
      api.rerender('bcec77b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/Lottery/LotteryIndex.vue"
export default component.exports